import { render, staticRenderFns } from "./List.vue?vue&type=template&id=531aa6fd&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=531aa6fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531aa6fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531aa6fd')) {
      api.createRecord('531aa6fd', component.options)
    } else {
      api.reload('531aa6fd', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=531aa6fd&scoped=true&", function () {
      api.rerender('531aa6fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/winners/List.vue"
export default component.exports